import React from 'react';
import ManageLocations from '../../../../components/manage-locations/manageLocations';
import { withRouter } from '../../../../util/router-compatibility';
import { UnleashService } from '../../../services';
import { withUnleash } from '../../../core/unleash';
import { ManageLocationsV2 } from '../components';

const ManageLocationsContainer = (props) => {
  const { unleashProps } = props;

  const isV2Enabled = unleashProps.isFlagEnabled(UnleashService.FLAGS.LOCATION_MANAGEMENT_V2);

  return isV2Enabled ? <ManageLocationsV2 {...props} /> : <ManageLocations {...props} />;
};

export default withUnleash(withRouter(ManageLocationsContainer), UnleashService.FLAGS.LOCATION_MANAGEMENT_V2);
